/**
 * CSGTorus3D registration: the parser.
 */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseCSGTorus3D } from './parser';
const cSGTorus3DRegistration = {
    typeName: 'CSGTorus3D',
    parser: parseCSGTorus3D,
};
nodeRegistry.register(cSGTorus3DRegistration);
//# sourceMappingURL=index.js.map